import { SocietePatrimoineHierarchieSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const SocietePatrimoineHierarchieModel: SelectorModel = {
  name: 'societePatrimoineHierarchies',
  getSelector: SocietePatrimoineHierarchieSelectors.selectAllSocietePatrimoineHierarchiesDictionary,
  isReady: SocietePatrimoineHierarchieSelectors.selectIsReadySocietePatrimoineHierarchie
};
